<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>{{ title }}</span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>
